
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const ReplicaSet = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    ["none",theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="ReplicaSet" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" fill={colorArray[0]} className="color0"  viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[1]} className="color1"  d="M16 0H0v16h16V0z" opacity=".01" />
  <path fill={colorArray[1]} className="color1"  d="M4.44 16L0 10.29l1.584-7.12099L8 0l6.415 3.16901L16 10.29 11.56 16H4.44zM2.38699 3.77299L1 10l3.884 5h6.231L15 10l-1.387-6.231L8 1 2.38699 3.77299zM11 12H3V7h8v5zm-7-1h6V8H4v3zm8-1V9h1v1h-1zm0-2V7h1v1h-1zm0-2V5h1v1h-1zm-2 0V5h1v1h-1zM8 6V5h1v1H8zM6 6V5h1v1H6zM4 6V5h1v1H4z" />
</svg>
    </HvIconBase>
)};

ReplicaSet.propTypes = HvIconBase.propTypes;

export default ReplicaSet;